// models/Appointment/AppointmentExternalDTO.ts
import { emptyUserDTO, User } from 'modules/users/models/User'
import { ExternAppointment } from './ExternAppointment'
import { v4 as uuidv4 } from 'uuid'
import { toModel as userToModel } from '../../users/models/User'
import {
  emptyExternAppointmentScheduleDTO,
  toModel as scheduleToModel,
} from './ExternAppointmentScheduleDTO'
import { ExternAppointmentSchedule } from './ExternAppointmentSchedule'

export interface ExternAppointmentDTO {
  id: string | undefined
  requester: User
  patient: User
  professional: User
  scheduleId: string
  schedule: ExternAppointmentSchedule
  status: number
  rate?: number | null
  date: Date
  initialMessage?: string
  cancelMessage?: string
  rateMessage?: string
  cancelUserId?: string | null
  createdAt: string
  updatedAt: string
}

export function emptyExternAppointmentDTO(): ExternAppointmentDTO {
  return {
    id: uuidv4(),
    requester: userToModel(emptyUserDTO()),
    patient: userToModel(emptyUserDTO()),
    professional: userToModel(emptyUserDTO()),
    scheduleId: '',
    schedule: scheduleToModel(emptyExternAppointmentScheduleDTO()),
    status: 0, // Requested
    rate: null,
    date: new Date(),
    initialMessage: undefined,
    cancelMessage: undefined,
    rateMessage: undefined,
    cancelUserId: null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
}

export function toModel(d: ExternAppointmentDTO): ExternAppointment {
  return new ExternAppointment({
    id: d.id,
    requester: d.requester,
    patient: d.patient,
    professional: d.professional,
    scheduleId: d.scheduleId,
    schedule: d.schedule,
    status: d.status,
    rate: d.rate,
    date: d.date,
    initialMessage: d.initialMessage,
    cancelMessage: d.cancelMessage,
    rateMessage: d.rateMessage,
    cancelUserId: d.cancelUserId,
    createdAt: d.createdAt,
    updatedAt: d.updatedAt,
  })
}

export function fromModel(a: ExternAppointment): ExternAppointmentDTO {
  return {
    id: a.id,
    requester: a.requester,
    patient: a.patient,
    professional: a.professional,
    scheduleId: a.scheduleId,
    schedule: a.schedule,
    status: a.status,
    rate: a.rate,
    date: a.date,
    initialMessage: a.initialMessage,
    cancelMessage: a.cancelMessage,
    rateMessage: a.rateMessage,
    cancelUserId: a.cancelUserId,
    createdAt: a.createdAt,
    updatedAt: a.updatedAt,
  }
}
